import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "_helpers";
// create slice = combination of reducer and action

const name = "asn";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });
//each slice have 3 elements first is name second is state, then reducer

// exports

export const asnActions = { ...slice.actions, ...extraActions };
export const asnReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    // initialize state from local storage to enable user to stay logged in
    data: [],
    createAsnRes: [],
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_OCTA_API_URL}/asn`;

  return {
    getAllAsn: getAllAsn(), 
    createAsn: createAsn(),
  };
  function createAsn() {
    return createAsyncThunk(`${name}/create`, async (data) => {
      await fetchWrapper.post(`${baseUrl}/create`, 
        data
      , 'multipart');
    });
  }
  function getAllAsn() {
    return createAsyncThunk(
      `${name}/fetchAsn/getById`,
      async (id) => await fetchWrapper.get(`${baseUrl}/fetchAsn/${id}`)
    );
  }
}
function createExtraReducers() {
  return (builder) => {
    getAllAsn();
    createAsn();
    function getAllAsn() {
      var { pending, fulfilled, rejected } = extraActions.getAllAsn;
      builder
        .addCase(pending, (state) => {
          state.scheduleItem = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.scheduleItem = { value: action.payload };
        })
        .addCase(rejected, (state, action) => {
          state.scheduleItem = { error: action.error };
        });
    }
    function createAsn() {
      var { pending, fulfilled, rejected } = extraActions.createAsn;
      builder
        .addCase(pending, (state) => {
          state.createAsnRes = { loading: true };
        })
        .addCase(fulfilled, (state, action) => {
          state.createAsnRes = { value: action.payload };
        })
        .addCase(rejected, (state, action) => {
          state.createAsnRes = { error: action.error };
        });
    }
  };
}
